import ru from 'date-fns/locale/ru'
import customHeaders, { getSpace } from '../../../common/headers'
import { SingleDatePicker } from '../../SingleDatePicker/SingleDatePicker'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { RavshanHttps } from '../../../fetchUrls'
import { Tabs, InputDinamycPlaceholder, TextareaDynamicPlaceholder, Checkbox, SelectExecutor, ButtonBasic } from "@lk-gtcom/ecomlab-components"
import { DynamicFormComponent } from '../../DynamicFormComponent/DynamicFormComponent'
import useGeneralStore from '../../../store/general'
import { TitlePage } from '../../TitlePage/TitlePage'
import { usePushNotifications } from '../../../common/pushNotification'
import './ModalAddTask.scss'
import { TextPage } from '../../TextPage/TextPage'
import { useResponseHandler } from '../../../common/auth';
import { ModalComponent } from '../ModalComponent/ModalComponent'

const btn_tab = [
    { label: 'Мероприятия', value: 1 },
    { label: 'Задачи', value: 2 }
]

const formateData = (data) => {
    const curr_data = data.map((el) => {

        return {
            id: el?.id,
            data_type: el?.attribute_type,
            attribute_name: el?.attribute_name,
            description: el?.description,
            required: el?.required,
            event_type_id: el?.event_type_id,
            sort_order: el?.sort_order
        }
    })
    return curr_data
}

function convertUTCtoTimezone(utcString, offsetHours = 3) {
    const date = new Date(utcString);

    // Создаем новую дату с учетом смещения
    const offsetDate = new Date(date.getTime() + offsetHours * 3600000);

    // Получаем компоненты даты
    const year = offsetDate.getUTCFullYear();
    const month = String(offsetDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(offsetDate.getUTCDate()).padStart(2, '0');
    const hours = String(offsetDate.getUTCHours()).padStart(2, '0');
    const minutes = String(offsetDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(offsetDate.getUTCSeconds()).padStart(2, '0');

    // Миллисекунды (преобразуем в микросекунды - добавляем три нуля)
    const ms = String(date.getUTCMilliseconds()).padStart(3, '0');
    const microseconds = ms + '000'; // .000 становится .000000

    // Формируем смещение часового пояса
    const offsetSign = offsetHours >= 0 ? '+' : '-';
    const offsetAbs = String(Math.abs(offsetHours)).padStart(2, '0');
    const timezone = `${offsetSign}${offsetAbs}:00`;

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${microseconds}${timezone}`;
}

const ModalAddTask = ({ ...props }) => {
    const {
        selectedEvent,
        setSelectedEvent,
        setIsModal,
        setAddEvent,
        eventInfo,
        setEventInfo,
        setModalInfo
    } = props

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    // Обработка ошибок
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

    const [eventId, setEventId] = useState(selectedEvent ? selectedEvent : null)
    const [isCreate, setIsCreate] = useState(selectedEvent ? true : false)

    // Атрибуты
    const [attributesEvent, setAttributesEvent] = useState([])
    const [attributesTask, setAttributesTask] = useState([])

    const [startDate, setStartDate] = useState(eventInfo ? (eventInfo?.dateFrom ? new Date(eventInfo?.dateFrom) : new Date()) : new Date())
    const [endDate, setEndDate] = useState(eventInfo ? (eventInfo?.dateTo ? new Date(eventInfo?.dateTo) : new Date()) : new Date())

    const [executorOptions, setExecutorOptions] = useState([])

    // Поля
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')

    const [typeId, setTypeId] = useState(null)

    // Кастомные поля
    const [fields, setFilds] = useState([]);

    const [pageValue, setPageValue] = useState(btn_tab[0].value)
    const activeTab = useParams()['*']

    useEffect(() => {
        fetchPossibleAttendees()
    }, [selectedSpace])

    const fetchPossibleAttendees = () => {
        const url = `${RavshanHttps}/api/v2/tasks/get_client_team`
        fetch(url, { headers })
            .then(handleTableResponse)
            .then(json => setExecutorOptions(json))
            .catch(handleRequestError)
    }

    // Создать новое событие.
    const fetchCreateEvent = () => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event`

        const body = JSON.stringify({
            event_type_id: pageValue,
            start_time: convertUTCtoTimezone(startDate),
            end_time: convertUTCtoTimezone(endDate),
            attributes: [
                // {
                //     event_type_attribute_id: pageValue === 1 ? 1 : 7,
                //     attribute_value: flex-startDate
                // },
                // {
                //     event_type_attribute_id: pageValue === 1 ? 2 : 8,
                //     attribute_value: flex-endDate
                // }
            ],
            title,
            description,
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => {
                addSuccessPush('Событие успешно создано')
                setIsCreate(true)
                setEventId(json?.id)
            })
            .catch(handleRequestError)
    }

    // Получить информацию события для дальнейшего редактирования
    const fetchGetEvent = (abortController = new AbortController()) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${selectedEvent}`;

        fetch(url, { method: 'GET', headers, signal: abortController.signal, })
            .then(res => res.json())
            .then(json => {
                const {
                    start_time,
                    end_time,
                    description,
                    event_type_id,
                    title
                 } = json || {}

                if (title) {
                    setTitle(title)
                }
                if (description) {
                    setDescription(description)
                }
                if (start_time) {
                    setStartDate(new Date(start_time))
                }
                if (end_time) {
                    setEndDate(new Date(end_time))
                }
                if (event_type_id) {
                    setTypeId(event_type_id)
                }
            })
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return;
            });
    };

    // Получить информацию события для дальнейшего редактирования
    const fetchGetFields = (abortController = new AbortController()) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${selectedEvent}/custom-attribute`;

        fetch(url, { method: 'GET', headers, signal: abortController.signal, })
            .then(handleTableResponse)
            .then(json => console.log(json))
            .catch(handleRequestError)
            .finally(() => {
                if (abortController.signal.aborted) return;
            });
    };


    // запись полей
    const fetchSetValue = (id, value) => {
        if (!eventId) return
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/attributes`

        const body = JSON.stringify({
            attributes: [
                {
                    event_type_attribute_id: id,
                    attribute_value: value
                }
            ]
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => { })
            .catch(err => console.error(err))
    }

    // Изменение заголовка
    const fetchSetTitle = () => {
        if (!eventId) return
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/title`

        const body = JSON.stringify({
            title
        })

        fetch(url, { body, method: 'PATCH', headers })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => { })
            .catch(handleRequestError)
    }

    // Изменение комментария
    const fetchSetComment = () => {
        if (!eventId) return
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/description`

        const body = JSON.stringify({
            description
        })

        fetch(url, { body, method: 'PATCH', headers })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => { })
            .catch(handleRequestError)
    }

    // Изменение даты начала
    const fetchSetStartDate = (startDate) => {
        if (!eventId) return
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/start_time`

        const body = JSON.stringify({
            start_time: startDate
        })

        fetch(url, { body, method: 'PATCH', headers })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => { })
            .catch(handleRequestError)
    }

    // Изменение даты конца
    const fetchSetEndDate = (endDate) => {
        if (!eventId) return
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/end_time`

        const body = JSON.stringify({
            end_time: endDate,
        })

        fetch(url, { body, method: 'PATCH', headers })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.statusText;
                    addErrorPush(`Ошибка: ${errorMessage}`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => { })
            .catch(handleRequestError)
    }

    // Получает список типов событий.
    const fetchGetTypeEvent = (item, day) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event_type/list`

        fetch(url, { method: 'GET', headers })
            .then(res => res.json())
            .then(json => {
                setAttributesEvent(formateData(json?.[0]?.attributes))
                setAttributesTask(formateData(json?.[1]?.attributes))
            })
            .catch(handleRequestError)
    }

    // Получение полей
    const fetchGetCustomFields = (abortController = new AbortController()) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/space-custom-attribute`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const list = json.map(({ name, custom_attribute_id, type, value, possible_values, field_source }) => {

                    return {
                        front_name: name,
                        data_type: type,
                        id: custom_attribute_id,
                        value: (type == 'bool' || value === 'null') ? JSON.parse(value) : value,
                        possible_values: possible_values,
                        field_source: field_source
                    };
                });

                setFilds(list)
            })
            .catch(handleRequestError);
    };

    // Запись полей
    const fetchSetValueField = (id, value) => {
        let url = `https://apps0.ecomru.ru:4553/api/v1/event/${eventId}/space-custom-attribute`

        const body = JSON.stringify({
            custom_attribute_id: id,
            value: (typeof value == 'string' || Array.isArray(value)) ? value : JSON.stringify(value)
        })

        fetch(url, { method: 'POST', headers, body })
            .then(handleTableResponse)
            .then((json) => {})
            .catch(handleRequestError);
    };

    // Редактирование
    useEffect(() => {
        if (eventId) {
            fetchGetEvent()
            fetchGetFields()
            fetchGetCustomFields()
        }
    }, [eventId]);

    useEffect(() => {
        fetchGetTypeEvent()
    }, []);


    return (
        <ModalComponent
            title={!isCreate ? 'Создание события' : `${typeId ? (typeId === 1 ? "Мероприятие" : "Задача") : (pageValue === 1 ? "Мероприятие" : "Задача")
                } ID-${eventId}`}
            onClose={(e) => {
                setIsModal(false)
                setModalInfo(false)
                setEventInfo(undefined)
                setAddEvent(false)
                setSelectedEvent(null)
            }}
            style={{
                maxWidth: '1000px',
                height: 'auto'
            }}
            child={
                <div className={activeTab === "event" ? 'modal-add-event_tall' : 'modal-add-event'}>


                    {!isCreate && <Tabs
                        tabs={btn_tab}
                        pageValue={pageValue}
                        setPageValue={(e) => setPageValue(e)}
                        stopRedirect
                    />}

                    <div className='modal-add-event__content'>
                        <div className='modal-add-event__date-group'>
                            <label className='modal-add-event__label'>
                                <TextPage
                                    text='Дата начала'
                                />
                                <SingleDatePicker
                                    date={startDate}
                                    setDate={(e) => {
                                        setStartDate(e)
                                        if (isCreate) {
                                            fetchSetStartDate(e)
                                        }
                                    }}
                                    locale={ru}
                                    // minDate={new Date()}
                                    time
                                />
                            </label>

                            <label className='modal-add-event__label'>
                                <TextPage
                                    text='Дата конца'
                                />
                                <SingleDatePicker
                                    date={endDate}
                                    setDate={(e) => {
                                        setEndDate(e)
                                        if (isCreate) {
                                            fetchSetEndDate(e)
                                        }
                                    }}
                                    locale={ru}
                                    minDate={startDate}
                                    time
                                />
                            </label>
                        </div>

                        <InputDinamycPlaceholder
                            onChange={setTitle}
                            changeValue={title}
                            type="text"
                            placeholder='Добавьте название'
                            autoComplete={false}
                            size='s'
                            onBlur={(e) => {
                                if (isCreate) {
                                    fetchSetTitle()
                                }
                            }}
                        />

                        <TextareaDynamicPlaceholder
                            width='100%'
                            changeValue={description}
                            placeholder={'Описание'}
                            onChange={(e) => setDescription(e)}
                            onBlur={(e) => {
                                if (isCreate) {
                                    fetchSetComment()
                                }
                            }}
                        />

                        {isCreate && <>
                            {/* <InputDinamycPlaceholder
                            onChange={setVenue}
                            changeValue={venue}
                            type="text"
                            placeholder='Место проведения'
                            autoComplete={false}
                            size='s'
                            onBlur={(e) => {
                                // fetchSetValue(3, venue)
                            }}
                        />

                        <SelectExecutor
                            executors={guests}
                            setExecutors={setGuests}
                            executorOptions={executorOptions}
                            title="Список приглашенных гостей"
                            placeholder="Назначить"
                            multi
                        /> */}

                            <TitlePage
                                medium
                                title={`Дополнительные поля`}
                            />

                            <DynamicFormComponent
                                productTemporary={fields}
                                fetchSetValue={fetchSetValueField}
                            />
                        </>}
                    </div>

                    {!isCreate && <ButtonBasic
                        size='56px'
                        green
                        text='Создать'
                        disabled={!title}
                        onClick={fetchCreateEvent}
                        style={{
                            marginTop: 'auto'
                        }}
                    />}
                </div>
            }
        />
    )
}

export { ModalAddTask }